import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { ClosingSection } from './components/ClosingSection';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-coral/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <AudienceSection data-id="element-5" />
        <ClosingSection data-id="element-6" />
      </main>
    </div>;
}